// HTTP Services
import SettlementService from "services/http/endpoints/settlement";
// Utilities
import showNotify from "helpers/notify";

function useSettlement() {
	async function getSettlements() {
		return await SettlementService.search({ size: 1000 });
	}

	async function requestSettlement(amount: number) {
		await SettlementService.request(amount);

		showNotify({
			text: "درخواست تسویه با موفقیت ثبت شد.",
		});
	}

	async function requestSettlementBySheba(data: Settlement.RequestBySheba) {
		await SettlementService.requestBySheba(data);

		showNotify({
			text: "درخواست تسویه با موفقیت ثبت شد.",
		});
	}

	return {
		getSettlements,
		requestSettlement,
		requestSettlementBySheba,
	};
}

export default useSettlement;
